import { CheckInStatsData } from '../../../types/checkInStats';
import { AnalyticsCard } from '../../AnalyticsCard';

interface StatsCardsProps {
  stats: CheckInStatsData;
}

export function StatsCards({ stats }: StatsCardsProps): JSX.Element {
  return (
    <div className="flex flex-row justify-between flex-wrap gap-8 items-center mb-4">
      <AnalyticsCard
        title="Average Check-Ins"
        percentage={stats.averageCheckIns.percentage || 0}
        trend={stats.averageCheckIns.trend || 0}
      />
      <AnalyticsCard
        title="Mid-Day Check-Ins"
        percentage={stats.midDayCheckIns.percentage || 0}
        // trend={stats.midDayCheckIns.trend || 0}
      />
      <AnalyticsCard
        title="Day-End Check-Ins"
        percentage={stats.dayEndCheckIns.percentage || 0}
        // trend={stats.dayEndCheckIns.trend || 0}
      />
    </div>
  );
}
